import { parseDateForStorage } from './importLogsParsingTime';

const FUTURE_IMPORT_DATE_HINT_PATTERN = /\b(?:scheduled|schedule|upcoming|tomorrow|next\s+(?:week|month|monday|tuesday|wednesday|thursday|friday|saturday|sunday))\b/i;
const DAY_IN_MS = 24 * 60 * 60 * 1000;
const DEFAULT_FUTURE_ROLLOVER_THRESHOLD_DAYS = 7;

const startOfDay = (value) => {
  const date = value instanceof Date ? value : parseDateForStorage(value);
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return null;
  }

  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export const looksLikeFuturePlannedImportText = (text = '') => (
  FUTURE_IMPORT_DATE_HINT_PATTERN.test(String(text || '').trim())
);

export const resolveImportYearForMonthDay = ({
  monthIndex,
  day,
  fallbackDate = new Date(),
  sourceText = '',
  futureRolloverThresholdDays = DEFAULT_FUTURE_ROLLOVER_THRESHOLD_DAYS,
} = {}) => {
  const normalizedMonthIndex = Number(monthIndex);
  const normalizedDay = Number(day);
  const resolvedFallbackDate = startOfDay(fallbackDate) || startOfDay(new Date());

  if (!Number.isFinite(normalizedMonthIndex) || !Number.isFinite(normalizedDay) || !resolvedFallbackDate) {
    return {
      year: new Date().getFullYear(),
      strategy: 'fallback_current_year',
      adjustedToPast: false,
      futureOffsetDays: 0,
      futurePlanned: false,
    };
  }

  const fallbackYear = resolvedFallbackDate.getFullYear();
  const candidateDate = new Date(fallbackYear, normalizedMonthIndex, normalizedDay);
  const futureOffsetDays = Math.round((candidateDate.getTime() - resolvedFallbackDate.getTime()) / DAY_IN_MS);
  const futurePlanned = looksLikeFuturePlannedImportText(sourceText);
  const shouldShiftToPreviousYear = futureOffsetDays > futureRolloverThresholdDays && !futurePlanned;

  return {
    year: shouldShiftToPreviousYear ? fallbackYear - 1 : fallbackYear,
    strategy: shouldShiftToPreviousYear
      ? 'shifted_to_previous_year'
      : (futureOffsetDays > 0 ? 'fallback_year_future' : 'fallback_year'),
    adjustedToPast: shouldShiftToPreviousYear,
    futureOffsetDays,
    futurePlanned,
  };
};

export default resolveImportYearForMonthDay;
